import { motion } from "framer-motion";

export default function Signature({ content }) {
  const dishes = content.signature || [];
  return (
    <section id="platos" className="relative py-24 md:py-36 bg-[#1a1a1a] text-[#f9f6f0] grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-[#da251d] uppercase tracking-[0.3em] text-xs font-semibold mb-4">Los favoritos</p>
            <h2 className="font-display text-4xl md:text-6xl font-bold leading-none tracking-tight">
              Platos de autor
            </h2>
          </div>
          <p className="max-w-sm text-white/60 leading-relaxed">
            Cada plato preparado al momento con ingredientes frescos y el auténtico sabor del wok peruano.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {dishes.map((d, i) => (
            <motion.article
              key={d.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative ${i % 2 === 1 ? "lg:translate-y-8" : ""}`}
              data-testid={`signature-dish-${i}`}
            >
              <div className="relative overflow-hidden aspect-[3/4] bg-stone-800">
                {d.image ? (
                  <img
                    src={d.image}
                    alt={d.name}
                    className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                  />
                ) : (
                  <div className="h-full w-full flex items-center justify-center text-white/30 font-display text-2xl">
                    {d.name}
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <span className="absolute top-4 right-4 rounded-full bg-[#da251d] text-white text-sm font-bold px-3 py-1">
                  {d.price}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="font-display text-2xl font-semibold">{d.name}</h3>
                  <p className="text-white/70 text-sm mt-1 max-h-0 opacity-0 overflow-hidden transition-all duration-500 group-hover:max-h-28 group-hover:opacity-100">
                    {d.description}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
